"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubscriptionsSection = void 0;
var _analyticsData = require("@ori/analytics-data");
var _basketItem = require("@ori/basket-item");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../api");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _CustomerSubscriptions = require("./CustomerSubscriptions");
var _SubscriptionFooter = require("./SubscriptionFooter");
var _jsxRuntime = require("react/jsx-runtime");
const EXPANDED_PACKAGE_AMOUNT = 10;
const SubscriptionsSection = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { isPersonalSubscriptionsEnabled, subscriptions } = (0, _contexts.useBasketContext)();
    const { isSimplifiedCheckout } = (0, _contexts.useCheckoutBasket)();
    const testId = getTestId('subscriptions');
    const subscriptionItemCodes = (0, _react.useMemo)(()=>{
        const subscriptionItemCodesTemp = [];
        if (subscriptions.length > 0) {
            for (const subscription of subscriptions){
                for (const subscriptionPackage of subscription.packages){
                    for (const subscriptionPackageItem of subscriptionPackage.items){
                        if (!subscriptionItemCodesTemp.includes(subscriptionPackageItem.itemCode)) {
                            subscriptionItemCodesTemp.push(subscriptionPackageItem.itemCode);
                        }
                    }
                }
            }
        }
        return subscriptionItemCodesTemp;
    }, [
        subscriptions
    ]);
    const { subscriptionItemInfo, isSubscriptionsReplacementsLoading } = (0, _api.useSubscriptionsReplacementQuery)(subscriptionItemCodes);
    const amountOfPackages = subscriptions.reduce((acc, curr)=>acc + curr.packages.length, 0);
    const isExpanded = amountOfPackages > 0 && amountOfPackages <= EXPANDED_PACKAGE_AMOUNT;
    if (Boolean(isPersonalSubscriptionsEnabled) || subscriptions.length < 1 || isSubscriptionsReplacementsLoading) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_basketItem.BasketSection, {
        "data-testid": testId,
        title: formatMessage('subscriptions'),
        overrideMdMaxWidth: isSimplifiedCheckout ? undefined : "".concat(_constants.MAX_WIDTH, "px"),
        children: [
            subscriptions.map((subscription)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_CustomerSubscriptions.CustomerSubscriptions, {
                    isExpanded: isExpanded,
                    subscription: subscription,
                    subscriptionItemInfo: subscriptionItemInfo,
                    placement: _analyticsData.Placement.Subscriptions,
                    "data-testid": testId
                }, "".concat(subscription.customerId, "-").concat(isExpanded))),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SubscriptionFooter.SubscriptionFooter, {})
        ]
    });
};
exports.SubscriptionsSection = SubscriptionsSection;
